import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'universal-scripts';
import { useIsMobile } from './useIsMobile';

export const useSidebar = () => {
	const isMobile = useIsMobile();
	const dispatch = useAppDispatch();
	const showSidebar: boolean = useAppSelector((s) => s.sidebar);

	const setShowSidebar = useCallback(
		(show) => {
			dispatch(show ? { type: 'sidebar/shown' } : { type: 'sidebar/hide' });
		},
		[dispatch]
	);
	const handleShowSidebar = () => {
		if (isMobile) setShowSidebar(!showSidebar);
	};

	useEffect(() => {
		setShowSidebar(!isMobile);
	}, [isMobile, setShowSidebar]);

	return {
		showSidebar,
		handleShowSidebar,
		setShowSidebar
	};
};
